import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';

export default class UserService {
  static async userProfileUpdate({ id, data }) {
    return await api.put(`${API_URLS.UPDATE_ADVISER_V3}/${id}`, data);
  }

  static async restorePassword() {
    return Promise.resolve('success');
  }

  static async resetPassword() {
    return Promise.resolve('success');
  }

  static async login(data) {
    return api.post(API_URLS.LOGIN, data);
  }

  static async registration(data) {
    return await api.post(API_URLS.REGISTER_V3, data);
  }

  static async forgotPasswordRequest(email) {
    return await api.post(API_URLS.FORGOT_PASSWORD_REQUEST, email);
  }

  static async forgotPasswordReset(data) {
    return await api.put(API_URLS.FORGOT_PASSWORD_RESET, data);
  }

  static async verifyEmail({ code }) {
    return await api.put(API_URLS.VERIFY_EMAIL + `?code=${code}`);
  }

  static async confirmEmail(hash) {
    return await api.post(`${API_URLS.CONFIRM_EMAIL}/${hash}`);
  }

  static async emailChange(data) {
    return await api.put(API_URLS.CHANGE_EMAIL, data);
  }

  static async emailResend(data) {
    return await api.put(API_URLS.RESEND_EMAIL, data);
  }

  static async updateEmail({ id, email }) {
    return await api.put(`${API_URLS.UPDATE_EMAIL}/${id}/email`, email);
  }

  static async updateUserPhones({ id, phones }) {
    return await api.patch(`${API_URLS.ADVISOR_V3}/${id}/phone`, phones);
  }

  static async updateUserRole({ id, role }) {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}/role`, { role });
  }

  static async updateUserData({ id, data }) {
    return await api.put(`${API_URLS.ADVISORS_V3}/${id}`, data);
  }

  static async updatePassword({ id, password }) {
    return await api.put(
      `${API_URLS.UPDATE_PASSWORD}/${id}/password`,
      password,
    );
  }

  static async getAdvisorById(id) {
    return await api.get(`${API_URLS.ADVISOR_V3}/${id}`);
  }

  static async checkToken() {
    return await api.get(API_URLS.CHECK_TOKEN);
  }

  static async getQRCodeBankID() {
    return await api.post(API_URLS.BANKID_AUTH);
  }

  static async getQRCodeSignBankID(number) {
    return await api.post(API_URLS.BANKID_SIGN, { personal_number: number });
  }

  static async getQRCodeAttachBankID(number) {
    return await api.post(API_URLS.BANKID_SIGN_ATTACH, {
      personal_number: number?.toString(),
    });
  }

  static async collectBankID(ref) {
    return await api.get(`${API_URLS.BANKID_COLLECT}?order_ref=${ref}`);
  }

  static async getTwoFactorSecret() {
    return await api.post(API_URLS.GET_SECRET, {});
  }

  static async getTwoFactorSecretCheck(payload) {
    return await api.post(API_URLS.SECRET_BIND, payload);
  }

  static async clearIdentification(id) {
    return await api.delete(`${API_URLS.ADVISOR_V3}/${id}/identification`);
  }

  static async setPreferredTheme({ userId, theme }) {
    return await api.patch(`${API_URLS.ADVISOR_V3}/${userId}/theme`, { theme });
  }
}
